{
  "roles": {
    "copyLinePermission": "Line Copying",
    "copyPermission": "Copying",
    "createLinePermission": "Line Creation",
    "createPermission": "Creation",
    "deletePermission": "Deletion",
    "editLinePermission": "Line Editing",
    "editPermission": "Editing",
    "exportPermission": "Table Export",
    "title": "Helios"
  },
  "recordDetail": {
    "recordNotFound": "Record not found. Redirecting to overview.",
    "entry": "Entry detail",
    "template": {
      "description": "Template description:",
      "status": "Status:",
      "name": "Template name:",
      "created": "Created:"
    }
  },
  "templates": {
    "prefilters": {
      "codeListItem": "Value from code list",
      "templateItem": "Value from template"
    },
    "conditions": {
      "actionsTitle": "Actions",
      "actions": {
        "Edit": "Edit",
        "EditInRow": "Edit in row",
        "Delete": "Delete",
        "Create": "Create",
        "CreateInRow": "Create in row",
        "Copy": "Copy",
        "CopyInRow": "Copy in row",
        "Presave": "Presave",
        "ContinuousSave": "Continuous save",
        "AutomaticValue": "Automatic Value"
      },
      "automaticValueSettings": "Automatic Value Settings",
      "targetItem": "Target Item",
      "defaultValue": "Default Value",
      "saveCondition": "Save Condition",
      "condition": {
        "leftBracket": "Left bracket",
        "rightBracket": "Right bracket",
        "and": "And",
        "or": "Or",
        "source": "Source",
        "static": "Static value",
        "value": "Value",
        "empty": "Empty",
        "comparisonOperator": "Comparison operator",
        "comparisons": {
          "GreaterThan": "Greater than",
          "GreaterThanOrEqual": "Greater than or equal",
          "LessThan": "Less than",
          "LessThanOrEqual": "Less than or equal",
          "Empty": "Empty",
          "NotEmpty": "Not empty",
          "Null": "Null",
          "NotNull": "Not null",
          "Equals": "Equals",
          "NotEquals": "Not equals",
          "Contains": "Contains",
          "NotContains": "Does not contain",
          "Between": "Between",
          "DaysBefore": "Days before date"
        },
        "selectValue": "Select value",
        "roles": "Roles",
        "roleTags": "Role tags",
        "pickRole": "Specific role…",
        "pickRoleTag": "Role tag…",
        "daysBefore": {
          "label": "Number of days before",
          "error": "Enter a whole number 0–3650",
          "sourceError": "Source must be a date field"
        }
      },
      "sources": {
        "HeliosUser": "Helios user",
        "HeliosUserId": "Helios user ID",
        "UserReference": "User reference",
        "UserRole": "User role",
        "UserEmail": "User email",
        "ContactEmail": "User contact email",
        "DateTimeNow": "Date and time now",
        "DateNow": "Date now"
      },
      "states": {
        "Visible": "Visibility",
        "Editable": "Editability",
        "DefaultValue": "Default value",
        "AutomaticValue": "Automatic value",
        "Highlight": "Highlight",
        "Collapsed": "Section collapse",
        "Required": "Required value"
      },
      "parentRecordRef": {
        "parentRecordRelationItemId": "Parent record attribute",
        "parentRecordRelationItemIdHelper": "Select an attribute from the parent record to pre-fill this field"
      },
      "toasts": {
        "errors": {
          "delete": "Error deleting condition",
          "add": "Error adding condition",
          "edit": "Error editing condition",
          "stateChanged": "Error changing condition state"
        },
        "success": {
          "delete": "Condition was successfully deleted",
          "add": "Condition was successfully added",
          "edit": "Condition was successfully edited",
          "stateChanged": "Condition state was successfully changed"
        }
      }
    },
    "notifications": {
      "notificationsTitle": "Settings",
      "notificationTemplate": "Notification Template",
      "isTaskNotification": "Is Task Notification",
      "resolvesTask": "Resolves Task",
      "setParametersMapping": "Parameter Mapping",
      "functions": "Functions",
      "functionsOverview": "Overview functions",
      "functionsDetail": "Detail functions",
      "addFunction": "Add",
      "functionsSelection": "Function Selection",
      "parameter": "Parameter",
      "dataItem": "Column"
    },
    "invalidDetailTemplateId": "Invalid detail template ID",
    "dataModel": {
      "alias": "Help with possible aliases",
      "button": "Apply SQL query",
      "label": "SQL query",
      "placeholder": "You can write your SQL query here",
      "success": "SQL query was successfully added",
      "title": "Data model settings"
    },
    "forms": {
      "buttons": {
        "aggregationGroupItems": "Aggregation groups",
        "buttonItems": "Functions",
        "columnValueItems": "Column values",
        "externalItems": "External record",
        "userDefinedItems": "User defined fields",
        "delimiters": "Delimiters",
        "infoText": "Info text",
        "infoTextItems": "Info texts",
        "horizontalSolidDelimiter": "Horizontal solid line",
        "verticalSolidDelimiter": "Vertical solid line",
        "horizontalDashedDelimiter": "Horizontal dashed line",
        "verticalDashedDelimiter": "Vertical dashed line",
        "horizontalDottedDelimiter": "Horizontal dotted line",
        "verticalDottedDelimiter": "Vertical dotted line"
      },
      "globalSettings": "Global settings",
      "hasMobileLayout": "Has mobile layout",
      "hasWebLayout": "Has web layout",
      "copyWebToMobile": "Copy from Web",
      "copyWebToMobileConfirm": "Are you sure you want to copy the layout from Web? This will overwrite the current mobile layout.",
      "editTab": "Edit tab",
      "deleteTab": "Delete tab",
      "deleteTabConfirm": "Delete this tab? Sections will move to another tab. Duplicate names and matching titles will be renamed.",
      "editSubTab": "Edit sub-tab",
      "deleteSubTab": "Delete sub-tab",
      "deleteSubTabConfirm": "Are you sure you want to delete this sub-tab? All items in this sub-tab will be removed.",
      "subTabUnnamedHint": "This sub-tab has no name. Click the menu icon to name it.",
      "collapseConditions": {
        "title": "Section collapse conditions",
        "tooltip": "Collapse conditions",
        "ruleName": "Rule name",
        "addRule": "Add rule"
      },
      "item": {
        "basicSettings": {
          "basicInformation": "Basic Information",
          "displayType": {
            "label": "Display type",
            "value": "Value",
            "staticselection": "Static Selection",
            "browse": "Browse",
            "file": "File",
            "link": "Link",
            "button": "Button",
            "calendarname": "Calendar Name",
            "calendarcategory": "Calendar Category",
            "calendardatefrom": "Calendar Date From",
            "calendardateto": "Calendar Date To",
            "calendarallday": "Calendar All Day",
            "infotext": "Info text"
          },
          "sorting": "Sorting",
          "properties": "Properties",
          "advancedOptions": "Advanced Options",
          "buttonLabel": "Button label",
          "disableTriggerEvents": "Disable trigger events",
          "ordinalIndex": "Processing order",
          "isPresaveAllowed": "Is presave allowed",
          "showButtonDirectly": "Show directly on line",
          "label": "Label",
          "sortOrder": "Sort order",
          "sortType": {
            "label": "Sort type",
            "none": "None",
            "ascending": "Ascending",
            "descending": "Descending"
          },
          "title": "Basic settings"
        },
        "aggregation": {
          "title": "Overview aggregation",
          "isGrouped": "Group",
          "groupingOrder": "Grouping order",
          "aggregationType": "Calculate as",
          "groupedTooltip": "Grouping / aggregation is set for this item"
        },
        "formatting": {
          "alignment": "Alignment",
          "specificFormatting": "Specific Formatting",
          "align": {
            "center": "Center",
            "left": "Left",
            "right": "Right"
          },
          "dateTime": {
            "date": "Date",
            "datetime": "Date and time",
            "label": "Date format",
            "monthYear": "Month / year",
            "time": "Time"
          },
          "labelAlign": "Label align",
          "mathRound": {
            "arithmetic": "Arithmetic",
            "down": "Down",
            "label": "Math round",
            "up": "Up"
          },
          "maxValue": "Maximum value",
          "minValue": "Minimum value",
          "minGreaterThanMax": "Minimum value must not be greater than maximum value",
          "roundTo": {
            "tenthousandths": "Round to the nearest ten-thousandths",
            "thousandths": "Round to the nearest thousandths",
            "hundredths": "Round to the nearest hundredths",
            "tenths": "Round to the nearest tenths",
            "dozens": "Round to the nearest tens",
            "hundreds": "Round to the nearest hundreds",
            "thousands": "Round to the nearest thousands",
            "label": "Round to"
          },
          "separator": {
            "none": "None",
            "comma": "Comma",
            "dot": "Dot",
            "label": "Thousands separator",
            "space": "Space"
          },
          "showAsTime": "Show as time",
          "showAsTextArea": "Show as Text Area",
          "showPhoneOrMail": "Show Phone or Email",
          "showWebLink": "Show Web Link",
          "showAsRichText": "Show as Rich Text",
          "specialChars": "Special Characters",
          "title": "Formatting",
          "unit": "Unit",
          "valueAlign": "Value align",
          "buttonAlign": "Button align",
          "labelLayout": {
            "label": "Label layout",
            "sideBySide": "Side by side",
            "stacked": "Stacked"
          }
        },
        "settings": {
          "dynamicRelations": "Dynamic Relations",
          "fileFolder": "File Folder",
          "targetTemplate": "Target Template",
          "browse": {
            "dataSources": "Data Sources",
            "columnConfiguration": "Column Configuration",
            "advancedOptions": "Advanced Options",
            "filtering": "Filtering",
            "conditions": "Conditions",
            "allowMultipleSelection": "Allow multiple selection",
            "displayColumns": "Display columns",
            "displayColumnsHelp": "Drag columns to reorder them",
            "valueColumn": "Value column",
            "allowMultipleSelectionHint": "Multiple selection is only available when dynamic relation is set",
            "dynamicRelation": "Dynamic relation",
            "detailTemplate": "Detail template",
            "codeListTemplate": "Code list template",
            "entryTemplate": "Entry template"
          },
          "file": {
            "folder": "Folder",
            "viewMode": "View Mode",
            "viewModeTitle": "Attachment View Mode",
            "viewModeIcons": "Large Icons",
            "viewModeCompact": "Compact List"
          },
          "staticSelection": {
            "title": "Static options",
            "key": "DB value",
            "value": "Show as"
          },
          "infoText": {
            "content": "Content (rich text)",
            "title": "Info text",
            "empty": "No content available",
            "emptyHint": "Not filled yet",
            "filled": "filled",
            "copyToAll": "Copy to all languages",
            "edit": "Edit content"
          },
          "title": "Settings"
        }
      },
      "saveSuccess": "Form saved successfully",
      "inheritedHighlightConditionName": "Highlight condition",
      "inheritedVisibilityConditionName": "Visibility condition",
      "warning": {
        "removeItem": "Are you sure you want to delete the item?",
        "tabNameExists": "This tab name already exists"
      }
    },
    "functions": {
      "button": {
        "add": "Add function",
        "orderButtons": "Set button order"
      },
      "orderButtonsModal": {
        "title": "Set button order",
        "description": "Drag and drop functions to change the order of buttons.",
        "toasts": {
          "success": "Function order was saved"
        }
      },
      "selectDetailTemplateModal": {
        "title": "Select detail template"
      },
      "selectFunctionModal": { "title": "Select function" },
      "addFunctionModal": {
        "allowMultipleSelection": "Allow execution over multiple records",
        "requiresConfirmation": "Require confirmation before execution",
        "requiresSaveBeforeExecution": "Require save before execution",
        "showAsStandaloneButton": "Show as standalone button",
        "showAsStandaloneButtonDisabledBecauseItIsCommon": "Common functions are always shown as standalone button.",
        "openCreatedRecord": "Open created record",
        "openCreatedRecordTemplateId": "Template for opening created record",
        "title": "Add function",
        "titleUpdate": "Edit function",
        "functionName": "Function name",
        "tooltip": "Label",
        "aliasPc": "Alias PC",
        "aliasMobile": "Alias Mobile",
        "iconPc": "Icon PC",
        "iconMobile": "Icon Mobile",
        "colorPc": "Color PC",
        "colorMobile": "Color Mobile",
        "addParameter": "Add Parameter",
        "displayConditions": "Display Conditions",
        "displayConfiguration": "Display Configuration",
        "pcVersion": "PC VERSION",
        "mobileVersion": "MOBILE VERSION",
        "syncFromPc": "Sync from PC",
        "behaviorAndConditions": "Behavior and Conditions",
        "toasts": {
          "syncSuccess": "PC settings copied to mobile version"
        }
      },
      "triggerFunctionModal": {
        "title": "Run Function",
        "comment": "Comment",
        "success": "The function was successfully run",
        "error": "An error occurred while running the function"
      },
      "confirmFunctionModal": {
        "title": "Confirm Action",
        "text": "Do you want to run the function {{name}}?"
      },
      "parameterModal": {
        "titleAdd": "Add Parameter",
        "titleEdit": "Edit Parameter",
        "titleView": "View Parameter",
        "name": "Name",
        "labelText": "Label",
        "type": "Type",
        "order": "Order",
        "isRequired": "Required",
        "isMultiSelect": "Allow multiple selection",
        "templateBrowseId": "Codelist Template",
        "prefilter": {
          "title": "Prefilter Conditions",
          "conditions": "Conditions",
          "updated": "Prefilter conditions updated",
          "addPrefilter": "Add Prefilter",
          "condition": "Condition {{index}}",
          "description": "When picking a value, the code list shows only records matching all conditions.",
          "empty": "No conditions yet — the code list will be shown unfiltered."
        },
        "options": "Options",
        "addOption": "Add Option",
        "optionKey": "Name",
        "optionValue": "Value",
        "toasts": {
          "success": {
            "add": "Parameter was successfully added",
            "edit": "Parameter was successfully edited"
          }
        }
      }
    },
    "settings": {
      "dataSource": "Data Source",
      "device": {
        "label": "Device",
        "mobile": "Mobile",
        "web": "Web",
        "webAndMobile": "Web and mobile"
      },
      "displayAs": "Display as",
      "name": "Internal template name",
      "heg": {
        "label": "Class and folder",
        "classes": "Class",
        "folders": "Folder"
      },
      "module": "Module",
      "selectModuleModal": { "title": "Select module" },
      "selectDataSourceModal": { "title": "Select data source" },
      "selectTableModal": { "title": "Select table" },
      "order": "Template order",
      "related": {
        "button": "+ Add parent template",
        "columns": {
          "label": "Link columns",
          "modal": {
            "title": "Link columns",
            "linkColumn": "Link column ({{type}})"
          }
        },
        "label": "Parent template",
        "modal": {
          "title": "Select parent template",
          "template": "Select parent template",
          "type": "Select parent template type"
        }
      },
      "table": "Table",
      "template": "Template",
      "type": {
        "api": "API",
        "calendar": "Calendar",
        "codelist": "Code list",
        "detail": "Detail",
        "entry": "Entry",
        "label": "Template type",
        "overview": "Overview"
      },
      "visibility": "Visibility"
    },
    "templateImport": "Template Import",
    "templateCopy": "Copy template",
    "copyDisabledTooltip": "To copy a template, please select exactly one template from the list.",
    "templateCopySuccess": "Template was successfully copied",
    "deleteTemplateModal": {
      "title": "Delete template",
      "titlePlural": "Delete templates",
      "message": "Are you sure you want to delete this template? This action cannot be undone.",
      "messagePlural": "Are you sure you want to delete the selected templates? This action cannot be undone.",
      "success": "Template was successfully deleted",
      "error": "The template could not be deleted"
    },
    "exportTemplate": "Export templates",
    "exportDescription": "Checking a template will also export linked templates",
    "exportSummaryTitle": "Export content preview",
    "exportWithRelatedLabel": "with related templates",
    "exportOnlyThisLabel": "only this template",
    "userDefinedField": {
      "addAggregationGroup": "Add aggregation group",
      "addGroup": "Add group",
      "addItem": "Add item",
      "editGroup": "Edit group",
      "editAggregationGroup": "Edit aggregation group",
      "dataModelItem": "Data model item",
      "placeholder": {
        "group": "Name the group",
        "value": "Enter a value"
      },
      "type": {
        "none": "None",
        "count": "Count",
        "avg": "Average",
        "min": "Minimum",
        "max": "Maximum",
        "attribute": "From model",
        "concatenate": "Connection of strings",
        "date": "Date",
        "static": "Static value",
        "sum": "Sum",
        "time": "Time"
      }
    },
    "printConfigurations": {
      "title": "Print Configurations",
      "reportId": "Print Template Number",
      "name": "Print Name",
      "description": "Description",
      "order": "Order",
      "active": "Active",
      "add": "Add print configuration",
      "edit": "Edit print configuration",
      "sections": {
        "basic": "Basic information",
        "output": "Output",
        "reportDefinition": "Report definition",
        "filter": "Browse report filter",
        "arguments": "Report arguments"
      },
      "target": "Print target",
      "targets": {
        "file": "File",
        "printer": "Printer"
      },
      "fileFormat": "File format",
      "printerName": "Printer name",
      "copiesNumber": "Number of copies",
      "folderId": "Folder number",
      "fileName": "Server file name",
      "returnFileContent": "Return file content",
      "reportType": "Report type",
      "reportTypes": {
        "form": "Form",
        "browse": "Browse",
        "pureBrowse": "Browse without filtering"
      },
      "reportName": "Report name",
      "libraryName": "Library name",
      "classId": "Class number",
      "filterFolderId": "Filter folder",
      "filterId": "Filter number",
      "argumentName": "Argument name",
      "argumentValue": "Value",
      "argumentSkip": "Skip",
      "addArgument": "Add argument",
      "notSet": "Not set (default)",
      "linkToRelation": {
        "label": "Link to relation",
        "relationNumber": "Relation number",
        "conflict": "Link to relation cannot be combined with the option '{{option}}'.",
        "singleRecordOnly": "Link to relation is only supported when printing exactly one record."
      },
      "tooltips": {
        "title": "Print Templates",
        "linkToRelation": "Saves the printed PDF in Helios as an external document linked to the record. Only applies when printing a single record.",
        "linkToRelationId": "Helios relation number the document is linked through",
        "linkRequiresSingleRecord": "Printing with link to relation requires exactly one selected record",
        "noPrintConfigurations": "No print configurations",
        "selectRecordsToPrint": "Select records to print",
        "printSuccess": "Print operation completed successfully",
        "reportId": "Helios report number",
        "target": "Print target – file or printer",
        "fileFormat": "File format when printing to a file",
        "printerName": "Printer name when printing to a printer",
        "copiesNumber": "Number of copies. Used only when printing to a printer; ignored for file export",
        "fileName": "Full server-side file name when printing to a file. Not required when 'Return file content' is on – a temporary server file is used",
        "folderId": "Folder number when a browse (not form) report is selected",
        "returnFileContent": "Whether to return the file content (byte array) when printing to a file",
        "reportType": "Report type – form, browse with filtering, or browse without filtering (all data is printed per the report select; permanent filters and permissions are not applied)",
        "reportName": "Name of the report defined in the library",
        "libraryName": "Name of the library where the report is defined",
        "classId": "Class number",
        "filterFolderId": "Filter folder number",
        "filterId": "Filter number",
        "argumentName": "Parameter name",
        "argumentValue": "Parameter value",
        "argumentSkip": "Skip the argument while processing filter arguments"
      }
    },
    "versions": {
      "create": "Create a new version",
      "label": "versions"
    },
    "filters": {
      "title": "Filters",
      "activeFilters": "Active filters",
      "noActiveFilters": "No active filters",
      "addFilter": "Add filter",
      "editFilter": "Edit filter",
      "column": "Column",
      "operator": "Operator",
      "value": "Value",
      "logicalOperator": "Logical operator",
      "selectValue": "Select Value",
      "apply": "Apply filters",
      "updateFilter": "Update filter",
      "savedFilters": "Saved filters",
      "noSavedFilters": "No saved filters",
      "saveFilter": "Save filter",
      "deleteFilter": "Delete filter",
      "defaultFilter": "Default",
      "filterName": "Filter name",
      "filterNamePlaceholder": "Enter filter name",
      "setAsDefault": "Set as default",
      "loadFilter": "Load filter",
      "filterSaved": "Filter saved successfully",
      "filterDeleted": "Filter deleted successfully",
      "filterLoaded": "Filter loaded",
      "isBlank": "Blank",
      "isBlankEmpty": "Filter blank values",
      "isBlankNotEmpty": "Filter non-blank values",
      "fromValue": "From",
      "toValue": "To",
      "advancedMode": "Advanced",
      "addValue": "Add value",
      "pressEnter": "Press Enter to add"
    }
  },
  "datasources": {
    "title": "Data Sources",
    "createDataSource": "Create Data Source",
    "editDataSource": "Edit Data Source",
    "loginPurposes": {
      "placeholder": "Select from the list",
      "none": "None",
      "user": "User",
      "serviceAccount": "Service Account",
      "both": "User and Service Account"
    },
    "deleteDatasourcesModal": {
      "title": "Delete Data Source",
      "titlePlural": "Delete Data Sources",
      "message": "Are you sure you want to delete the data source?",
      "messagePlural": "Are you sure you want to delete the data sources?",
      "submit": "Delete",
      "success": "The data source was successfully deleted",
      "error": "Failed to delete the data source"
    },
    "form": {
      "name": "Name",
      "namePlaceholder": "Enter a name",
      "timeZone": "Time Zone",
      "profile": "Profile",
      "profilePlaceholder": "Enter a profile name",
      "url": "URL",
      "urlPlaceholder": "Enter URL",
      "basicLoginPurpose": "Non-Domain Mapping",
      "domainLoginPurpose": "Domain Mapping",
      "domain": "Domain",
      "domainPlaceholder": "Enter domain",
      "googleLoginPurpose": "Google Mapping",
      "microsoftLoginPurpose": "Microsoft Mapping",
      "maxConcurrentConnections": "Max. Concurrent Users",
      "sections": {
        "general": "General Settings",
        "loginMethods": "Login Methods",
        "accountMapping": "Account Mapping"
      },
      "defaultUserMapping": "Default User Mapping",
      "useDefaultUserMapping": "Use Default User Mapping",
      "defaultUserMappingError": "Please add a mapping or disable \"{{useDefaultUserMapping}}\"",
      "serviceAccount": "Service Account",
      "map": "Map",
      "unMap": "Unmap",
      "mappedAccount": "Mapped account",
      "notMapped": "Not mapped",
      "userMapping": "User Mapping",
      "userName": "Username",
      "userNamePlaceholder": "Enter username",
      "password": "Password",
      "passwordPlaceholder": "Enter password",
      "type": "Login type"
    },
    "mapping": {
      "domain": "Domain",
      "google": "Google",
      "login": "Username and password",
      "microsoft": "Microsoft",
      "noMapping": "No mapping options",
      "authWindowError": "Error opening login window",
      "success": "You have been successfully mapped",
      "error": "Mapping failed",
      "removeMappingTitle": "Remove mapping",
      "removeMappingConfirm": "Are you sure you want to remove the saved mapping?",
      "removeMappingSubmit": "Remove mapping",
      "removeMappingSuccess": "Mapping was successfully removed",
      "removeMappingError": "Mapping could not be removed",
      "invalidMapping": "The saved mapping to the data source is no longer valid. Please map yourself again."
    },
    "users": {
      "edit": "Edit user mapping",
      "modal": {
        "title": "Delete user mapping",
        "delete": {
          "title": "Delete user mapping",
          "message": "Are you sure you want to delete the user mapping?",
          "submit": "Delete",
          "success": "User mapping was successfully deleted",
          "error": "User mapping deletion failed"
        }
      }
    }
  },
  "tables": {
    "title": "Tables",
    "deleteConfirmation": "Are you sure you want to delete the selected tables? This action cannot be undone.",
    "modalAddtable": {
      "addColumn": "Add Column",
      "columnName": "Column Name",
      "editColumn": "Edit Column",
      "error": {
        "missingColumns": "Table must have at least one column",
        "uniqueName": "Table name must be unique"
      },
      "tableName": "Table Name",
      "tableNamePlaceholder": "Enter Table Name",
      "title": {
        "_": "Add Table",
        "create": "Add Table",
        "edit": "Edit Table",
        "selectDataSource": "Select Data Source",
        "selectTable": "Select Table"
      },
      "sorting": {
        "label": "Table sorting",
        "asc": "A to Z",
        "desc": "Z to A"
      },
      "unique": "Column is unique"
    },
    "successfully": {
      "created": "Tables were successfully created",
      "deleted": "Tables were successfully deleted",
      "updated": "Tables were successfully updated"
    }
  },
  "notificationTemplates": {
    "form": {
      "addParameter": "Add Parameter",
      "email": "Email Notification",
      "insertParam": "Insert Parameter",
      "name": "Notification Name",
      "parameter": "Parameter Name",
      "parameterExists": "This parameter already exists",
      "parameterRequired": "Parameter name is required to add parameter",
      "push": "Push Notification",
      "subject": "Subject",
      "text": "Notification Text",
      "web": "In-app Notification",
      "description": "Description",
      "title": "Title"
    },
    "confirmationModalForLeaving": {
      "title": "Are you sure you want to leave this page?",
      "description": "By confirming, you will leave the page and lose unsaved data."
    },
    "confirmationModalForRemoving": {
      "title": "Are you sure you want to remove this notification template?",
      "description": "By confirming, the template will be removed."
    },
    "title": {
      "listOfTemplates": "List of Notification Templates",
      "newConditions": "New Conditions"
    }
  },
  "functions": {
    "title": "Functions",
    "tooltips": {
      "noFunctions": "No function"
    },
    "toasts": {
      "error": "Something went wrong",
      "errors": {
        "delete": "Function could not be deleted",
        "edit": "Function could not be edited",
        "add": "Function could not be added",
        "import": "Function could not be imported"
      },
      "success": {
        "delete": "Function was successfully deleted",
        "edit": "Function was successfully edited",
        "add": "Function was successfully added",
        "import": "Function was successfully imported"
      }
    },
    "addFunctionTranslation": {
      "title": "Add Function",
      "buttons": {
        "add": "Add",
        "cancel": "Cancel",
        "addParameters": "Add Parameters"
      }
    },
    "addFunctionParametersModal": {
      "title": "Parameter detail",
      "buttons": {
        "add": "Add",
        "addOption": "Add option",
        "cancel": "Cancel",
        "addKeyValue": "Add",
        "select": "Select",
        "selectOverviewTemplate": "Select overview template",
        "update": "Update"
      },
      "fields": {
        "name": "Name",
        "type": "Type",
        "label": "Label",
        "maxCharCount": "Maximum characters (only for text field/text area)",
        "overviewSelect": "Overview selection",
        "key": "Key",
        "value": "Value",
        "isRequired": "Is required",
        "isMultiSelect": "Allow multiple selection",
        "order": "Parameter order",
        "options": "Options"
      },
      "types": {
        "Text": "Text",
        "Relation": "Relation",
        "Checkbox": "Checkbox",
        "Date": "Date",
        "Time": "Time",
        "DateTime": "Date and time",
        "Radio": "Single select",
        "Password": "Password",
        "File": "File",
        "MultiSelect": "Static select"
      }
    },
    "addFunctionModal": {
      "title": "Add Function",
      "buttons": {
        "add": "Save",
        "cancel": "Cancel",
        "addParameters": "Add Parameters"
      },
      "fields": {
        "sections": {
          "basicInfo": "Basic Information",
          "parameters": "Function Parameters",
          "settings": "Other Settings"
        },
        "name": "Name",
        "id": "Helios ID function",
        "isCommon": "Is common",
        "isEntryFunction": "General function",
        "dataSource": "Data source",
        "column": "Column",
        "functionType": "Type",
        "functionTypes": {
          "Heg": "Function",
          "HegWorkflow": "Workflow action"
        },
        "skipEntriesWithError": "Skip entries with error",
        "parentColumn": "Parent column",
        "functionWorkflowCommentType": "Comment type",
        "worflowCommentType": {
          "none": "None",
          "optional": "Optional",
          "required": "Required"
        }
      }
    },
    "importFunctionModal": {
      "title": "Import Function",
      "buttons": {
        "add": "Import",
        "cancel": "Cancel",
        "addParameters": "Add Parameters"
      },
      "fields": {
        "sections": {
          "basicInfo": "Basic Information",
          "importSettings": "Import Settings"
        },
        "name": "Name",
        "column": "Column",
        "functionType": "Type",
        "id": "Helios ID function",
        "isCommon": "Is common",
        "importCodeListTemplates": "Import code-list templates",
        "importCodeListTemplatesHelp": "Applies only to static Relation parameters. When enabled, select the module to assign to newly created templates.",
        "module": "Module",
        "isEntryFunction": "General function",
        "parentColumn": "Parent column",
        "dataSource": "Data source",
        "paramjson": "Parameter JSON",
        "skipEntriesWithError": "Skip entries with error",
        "functionWorkflowCommentType": "Comment type",
        "worflowCommentType": {
          "none": "None",
          "optional": "Optional",
          "required": "Required"
        }
      }
    },
    "editFunctionModal": {
      "title": "Edit row detail",
      "buttons": {
        "add": "Add",
        "cancel": "Cancel",
        "addParameters": "Add Parameters"
      },
      "fields": {
        "id": "Helios ID function",
        "name": "Name",
        "column": "Column",
        "type": "Type",
        "isCommon": "Is common",
        "isEntryFunction": "General function",
        "skipEntriesWithError": "Skip entries with error",
        "parentColumn": "Parent column",
        "dataSource": "Data source",
        "functionWorkflowCommentType": "Comment type",
        "worflowCommentType": {
          "none": "None",
          "optional": "Optional",
          "required": "Required"
        }
      }
    },
    "deleteFunctionsModal": {
      "title": "Delete function",
      "description": "Are you sure that you want to delete selected functions? This action is not revertable.",
      "buttons": {
        "delete": "Delete",
        "cancel": "Cancel"
      }
    }
  },
  "copyInRow": {
    "copy": "Copy",
    "copyInRow": "Copy in row"
  },
  "importTemplates": {
    "classFolders": "ID of classes and folders",
    "notificationTemplates": "Notification Templates",
    "runImport": "Run Import",
    "templateFunctions": "Template Functions",
    "classFoldersModal": {
      "classIdExists": "Class with this ID already exists",
      "title": "Edit class ID and folder"
    },
    "notificationTemplatesModal": {
      "new": "New notification template",
      "title": "Edit notification template",
      "original": "Original notification template"
    },
    "importTemplateModal": {
      "exportedTemplate": "Exported Template",
      "successfulyImported": "Template was successfully imported",
      "title": "Import Template",
      "uploadTemplate": "Upload Template"
    },
    "templateFunctionsModal": {
      "new": "New template function",
      "title": "Edit template function",
      "original": "Original template function"
    },
    "importMode": {
      "label": "Import mode",
      "newVersion": "New version",
      "freshCopy": "Fresh copy",
      "newVersionDesc": {
        "exists": "This template already exists. Importing will archive the current version.",
        "notExists": "This template does not yet exist in this environment. It will be created."
      },
      "freshCopyDesc": {
        "exists": "This template already exists. A new standalone copy will be created — the existing template remains unchanged.",
        "notExists": "This template does not yet exist. A standalone copy will be created."
      }
    },
    "warnings": {
      "title": "Warnings",
      "dismiss": "Dismiss",
      "browseTargetNotInBundle": "Browse reference outside bundle",
      "linkTargetNotInBundle": "Link reference outside bundle",
      "functionNotAutoResolved": "Function requires manual mapping",
      "realTimeFunctionOrphaned": "Real-time function reference will be removed"
    },
    "autoResolved": "Auto-resolved",
    "state": {
      "failed": "Failed"
    }
  },
  "listing": {
    "errorLoadData": "Error loading data from Helios, please try again later",
    "delete": {
      "confirm": "Are you sure you want to delete this record?"
    },
    "exportModal": {
      "title": "Export template {{name}}",
      "titleDetail": "Export item template {{name}}",
      "fileName": "File name",
      "fileType": "File type",
      "pageFormat": "Page format",
      "pageFormats": {
        "auto": "Automatic",
        "a5": "A5",
        "a4": "A4",
        "a3": "A3",
        "a2": "A2",
        "letter": "Letter"
      },
      "pagesToExport": "Number of pages to export (1-{{count}})",
      "exportAllPages": "Export all pages",
      "success": "The table was successfully exported",
      "tableType": "Table type",
      "tableTypes": {
        "table": "Items",
        "tableDetail": "Detail and items"
      }
    },
    "navigateError": "An error occurred while opening the record",
    "success": {
      "deleteRow": "The record was successfully deleted",
      "editRow": "The record was successfully edited",
      "createRow": "The record was successfully created"
    },
    "error": {
      "editRow": "Record {{rowId}} could not be saved"
    },
    "calendar": {
      "table": "Table",
      "calendar": "Calendar",
      "view": "View",
      "edit": "Edit",
      "delete": "Delete",
      "noDetailTemplate": "No detail template is linked to this calendar, so records cannot be added.",
      "noPermission": "You do not have permission to add records in this calendar."
    }
  }
}
